import { render } from "./ModelStatus.vue?vue&type=template&id=5e7cc34c&scoped=true"
import script from "./ModelStatus.vue?vue&type=script&lang=js"
export * from "./ModelStatus.vue?vue&type=script&lang=js"

import "./ModelStatus.vue?vue&type=style&index=0&id=5e7cc34c&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7cc34c"]])

export default __exports__